<template>
  <div id="app">
    <FrameLayout v-if="$route.query.theme"><router-view></router-view></FrameLayout>
    <DefaultLayout v-else><router-view></router-view></DefaultLayout>
  </div>
</template>

<script>
import DefaultLayout from '@/components/layouts/defaultLayout/DefaultLayout';
import FrameLayout from '@/components/layouts/frameLayout/FrameLayout';

export default {
  name: 'App',
  components: {
    DefaultLayout,
    FrameLayout,
  },
  methods: {
    handleSetLocale({ lang }) {
      this.$i18n.locale = lang;
    },
  },
  watch: {
    '$route.query.lang': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.handleSetLocale({ lang: newValue });
        }
      }
    }
  },
};
</script>
<style lang="scss">
$body-font-family: 'Ubuntu';
.v-application {
   font-family: $body-font-family, sans-serif !important;
 }
</style>